// Tabs component for product tabs
class TabsComponent extends HTMLElement {
  constructor() {
    super();
    this.tabLinks = this.querySelectorAll('.tab-link');
    this.tabContents = this.querySelectorAll('.tab-content');
    this.init();
  }

  init() {
    if (this.tabLinks.length === 0) return;

    this.tabLinks.forEach((link, index) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        this.switchTab(index);
      });

      link.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.switchTab(index);
        }
      });
    });
  }

  switchTab(index) {
    // Remove current class from all tabs and contents
    this.tabLinks.forEach(link => link.classList.remove('current'));
    this.tabContents.forEach(content => content.classList.remove('current'));

    // Add current class to selected tab and content
    if (this.tabLinks[index]) {
      this.tabLinks[index].classList.add('current');
    }
    if (this.tabContents[index]) {
      this.tabContents[index].classList.add('current');
    }
  }
}

// Register the custom element
if (!customElements.get('tabs-component')) {
  customElements.define('tabs-component', TabsComponent);
}
